import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { authedAtTimestampAtom } from '../auth/state';
import { useInitUserTracking } from '../hooks/useInitUserTracking';
import { visitorStateAtom } from './state';
import { useVisitorId } from './useVisitorId';
import { admissionAttemptsAtom } from './waiting-room/admission/state';

export function useInitVisitorUserTracking() {
  const visitorId = useVisitorId();
  const visitorState = useAtomValue(visitorStateAtom);
  const { providerShortId } = useParams();
  const admissionAttempts = useAtomValue(admissionAttemptsAtom);
  const joinAttempts = useAtomValue(admissionAttemptsAtom);
  const authedAtTimestamp = useAtomValue(authedAtTimestampAtom);

  const additionalVars = useMemo(
    () => ({ providerShortId, visitorState, admissionAttempts, joinAttempts, authedAtTimestamp }),
    [admissionAttempts, joinAttempts, providerShortId, visitorState, authedAtTimestamp],
  );

  useInitUserTracking(visitorId, additionalVars);
}
